"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "narcao": {
    "b6910d89": [{
      "hkey": "e8843e11",
      "slug": "is-cherchis-is-canes",
      "name": "Is Cherchis-Is Canes",
      "primary": true,
      "skipSearch": false
    }],
    "is-caneas": [{
      "hkey": "e8843e11",
      "slug": "is-cherchis-is-canes",
      "name": "Is Cherchis-Is Canes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "narcao"
    }],
    "54a3e7dc": [{
      "hkey": "e8843e11",
      "slug": "is-cherchis-is-canes",
      "name": "Is Cherchis-Is Canes",
      "primary": true,
      "skipSearch": false
    }],
    "is-cherchis": [{
      "hkey": "e8843e11",
      "slug": "is-cherchis-is-canes",
      "name": "Is Cherchis-Is Canes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;